"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgEmailOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2 6c0-1.333.667-2 2-2h16c1.333 0 2 .667 2 2v12c0 1.333-.667 2-2 2H4c-1.333 0-2-.667-2-2V6zm2 0v12h16V6H4zm0 0h1.414L12 12.588 18.58 6H20v1.43l-6.585 6.576c-.472.388-.943.582-1.415.581-.472 0-.943-.194-1.413-.583L4 7.41V6z' }))); };
exports.default = SvgEmailOutline;
//# sourceMappingURL=EmailOutline.js.map